import React from 'react';
import PropTypes from 'prop-types';
import { linkify } from '../util/helpers';

const EditorLink = (props) => {
  const {
    rel,
    target,
    decoratedText = '',
    children,
    ...otherProps // eslint-disable-line no-unused-vars
  } = props;

  const links = linkify.match(decoratedText);
  const href = links && links[0] ? links[0].url : '';

  const linkProps = {
    href,
    rel,
    target,
  };

  return <a {...linkProps}>{children}</a>;
};

export default EditorLink;

EditorLink.defaultProps = {
  rel: 'noreferrer noopener',
  target: '_blank',
};

EditorLink.propTypes = {
  decoratedText: PropTypes.string,
  children: PropTypes.node,
  href: PropTypes.string,
  rel: PropTypes.string,
  target: PropTypes.string,
};
